import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['days', 'hours', 'minutes', 'seconds']
  static values = { end: String, expired: Boolean }

  connect() {
    this.endDateTime = new Date(this.endValue).getTime()
    this.second = 1000
    this.minute = this.second * 60
    this.hour = this.minute * 60
    this.day = this.hour * 24

    if (this.#getDistance() < 0) {
      this.expiredValue = true
    } else {
      this.#updateTimer()
      window.countInterval = setInterval(() => this.#updateTimer(), 1000)
    }
  }

  #getDistance() {
    return this.endDateTime - new Date().getTime()
  }

  #updateTimer() {
    const distance = this.#getDistance()
    const days = Math.floor(distance / this.day)
    const hours = Math.floor((distance % this.day) / this.hour)
    const minutes = Math.floor((distance % this.hour) / this.minute)
    const seconds = Math.floor((distance % this.minute) / this.second)
    this.daysTarget.textContent = days
    this.hoursTarget.textContent = hours
    this.minutesTarget.textContent = minutes
    this.secondsTarget.textContent = seconds

    if (distance < 0) {
      clearInterval(window.countInterval)
      this.expiredValue = true
    }
  }
}
